import React, {useEffect, useState} from 'react';
import { Routes, Route } from 'react-router-dom';
import { useMedsStateSnapshot, useMedsHistoryStateSnapshot, useIngredientsStateSnapshot, useSupplementsStateSnapshot, useUserStateSnapshot, getCurrentUserId } from 'store/storeValtio';
import { getOnline, setOnline } from 'store/storeValtio';

import Schedule from '../schedule/Schedule';
import ProtectedRoute from '../../ProtectedRoute';
import MedicationList from '../medications/medicationList/MedicationList';
import MedicationDetails from '../medications/medicationDetails/medicationDetails';

import ExportMenu from '../export/ExportMenu';
import ExportMedsPrint from '../export/ExportMeds';
import ExportHistory from '../export/ExportHistory';
import MedicationArchive from '../export/medicationArchive/MedicationArchive';

import TakeMedForm from '../medications/TakeMedForm';
import AddMedication from '../medications/addMedication/AddMedication';
import ConditionTabs from '../tabs/ConditionTabs';
import ProfileForm from '../users/ProfileForm';
import NewUserForm from '../users/NewUserForm';
import ChangeUser from '../users/ChangeUser';
import DeleteUser from '../users/DeleteUser';
import Notifications from '../settings/notifications/Notifications';
import SortOrder from '../settings/sortOrder/SortOrder';
import Spinner from '../spinner/Spinner';
import BottomNav from './BottomNav';
import HistoryTabs from '../tabs/HistoryTabs';
import EditMedication from '../medications/addMedication/EditMedication';
import Development from '../settings/Development';
import IngredientList from '../ingredients/IngredientList';
import AddIngredient from '../ingredients/addIngredient/AddIngredient';
import EditIngredient from '../ingredients/addIngredient/EditIngredient';
import IngredientInfo from '../ingredients/IngredientInfo';
import SupAddIngredients from '../ingredients/SupAddIngredients';
import MedicationHistory from '../medications/medicationHistory/MedicationHistory';
import IngredientDetails from 'components/ingredients/IngredientDetails';
import ExportUser from '../export/ExportUser';
import ExportAll from 'components/export/ExportAll';
import ImportAll from 'components/export/ImportAll';
import SaveDataTest from 'components/export/SaveDataTest';
import HelpModal from 'components/help/HelpModal';
import ClearData from 'components/settings/ClearData';
import { loadDataFromDb } from 'helpers/generalHelpers';
import Cleanup from 'components/settings/Cleanup';
import AddPrescription from 'components/medications/prescriptions/AddPrescription';
import PrescriptionList from 'components/medications/prescriptions/PrescriptionList';
import HistorySummary from 'components/medications/medicationHistory/HistorySummary';
import UpdateOBData from 'components/settings/UpdateOBData';

export default function Dashboard() {
  //console.log('Dashboard', window.location.href);
  
  const [refresh, setRefresh] = useState({value: false});
  const us = useUserStateSnapshot();
  const ul = us.loaded;
  const ms = useMedsStateSnapshot();
  const ml = ms.loaded;
  const hs = useMedsHistoryStateSnapshot();
  const hl = hs.loaded;
  const is = useIngredientsStateSnapshot();
  const il = is.loaded;
  const ss = useSupplementsStateSnapshot();
  const sl = ss.loaded;

  useEffect(() => {
    //console.log("Dashboard UE");
    const interval = setInterval(() => {
      //console.log("interval");
      const ol = window.navigator.onLine;
      if (ol !== getOnline()) {
        setOnline(ol);
        console.log("online: ", ol)
      }
      setRefresh({...refresh, value: !refresh.value});
    }, 60000);
    return () => {
      //console.log('Dashboard UE return');
      clearInterval(interval);
    }
  });

  loadDataFromDb(getCurrentUserId());

  if ( !ml || !hl || !il | !sl || !ul) {
    //console.log("Dashboard not loaded", ul, ml, hl, il, sl);
    return ( <Spinner />)
  }

  return (
    <div id='dashboard'>
      <HelpModal />
      <div className='main'>
          <Routes>
            <Route path="/" element={<ProtectedRoute><MedicationList /></ProtectedRoute>}/>
            <Route path="/historyTabs/:tab" element={<ProtectedRoute><HistoryTabs /></ProtectedRoute>}/>
            <Route path="/schedule" element={<ProtectedRoute><Schedule /></ProtectedRoute>}/>
            <Route path="/condition" element={<ProtectedRoute><ConditionTabs /></ProtectedRoute>}/>
            <Route path="/history" element={<ProtectedRoute><MedicationHistory /></ProtectedRoute>}/>
            <Route path="/history/:id" element={<ProtectedRoute><MedicationHistory /></ProtectedRoute>}/>
            <Route path="/historySummary/:id" element={<ProtectedRoute><HistorySummary /></ProtectedRoute>}/>
            <Route path="/meds/:id" element={<ProtectedRoute><MedicationDetails /></ProtectedRoute>}/>
            <Route path="/take/:id/:source" element={<ProtectedRoute><TakeMedForm /></ProtectedRoute>}/>
            <Route path="/create" element={<ProtectedRoute><AddMedication /></ProtectedRoute>}/>
            <Route path="/create/:id" element={<ProtectedRoute><EditMedication /></ProtectedRoute>}/>

            <Route path="/sortOrder" element={<ProtectedRoute><SortOrder /></ProtectedRoute>}/>
            <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>}/>
            <Route path="/export" element={<ProtectedRoute><ExportMenu /></ProtectedRoute>}/>
            <Route path="/exportUser" element={<ProtectedRoute><ExportUser /></ProtectedRoute>}/>
            <Route path="/exportAll" element={<ProtectedRoute><ExportAll /></ProtectedRoute>}/>
            <Route path="/importAll" element={<ProtectedRoute><ImportAll /></ProtectedRoute>}/>
            <Route path="/exportMedsPrint" element={<ProtectedRoute><ExportMedsPrint /></ProtectedRoute>}/>
            <Route path="/savedatatest" element={<ProtectedRoute><SaveDataTest /></ProtectedRoute>}/>
            <Route path="/exportHistory" element={<ProtectedRoute><ExportHistory /></ProtectedRoute>}/>
            <Route path="/archive" element={<ProtectedRoute><MedicationArchive /></ProtectedRoute>}/>
            <Route path="/updateOB" element={<ProtectedRoute><UpdateOBData /></ProtectedRoute>}/>

            <Route path="/profile" element={<ProtectedRoute><ProfileForm /></ProtectedRoute>}/>
            <Route path="/addUser" element={<ProtectedRoute><NewUserForm /></ProtectedRoute>}/>
            <Route path="/changeUser" element={<ProtectedRoute><ChangeUser /></ProtectedRoute>}/>
            <Route path="/deleteUser" element={<ProtectedRoute><DeleteUser /></ProtectedRoute>}/>

            <Route path="/addPrescription/:id" element={<ProtectedRoute><AddPrescription /></ProtectedRoute>}/>
            <Route path="/prescriptions/:id" element={<ProtectedRoute><PrescriptionList /></ProtectedRoute>}/>

            <Route path="/ingredients" element={<ProtectedRoute><IngredientList /></ProtectedRoute>}/>
            <Route path="/ingredientInfo/:id" element={<ProtectedRoute><IngredientInfo /></ProtectedRoute>}/>
            <Route path="/ingredients/:id" element={<ProtectedRoute><IngredientList /></ProtectedRoute>}/>
            <Route exact path="/ingredientDetails/:inqId/:medId" element={<ProtectedRoute><IngredientDetails /></ProtectedRoute>}/>
            <Route path="/addIngredient/:id" element={<ProtectedRoute><AddIngredient /></ProtectedRoute>}/>
            <Route path="/editIngredient/:id" element={<ProtectedRoute><EditIngredient /></ProtectedRoute>}/>
            <Route path="/supAddIngredients/:id" element={<ProtectedRoute><SupAddIngredients /></ProtectedRoute>}/>
            <Route path="/ingredients" element={<ProtectedRoute><IngredientList /></ProtectedRoute>}/>

            <Route path="/cleanup" element={<ProtectedRoute><Cleanup /></ProtectedRoute>}/>
            <Route path="/clear" element={<ProtectedRoute><ClearData /></ProtectedRoute>}/>
            <Route path="/dev" element={<ProtectedRoute><Development /></ProtectedRoute>}/>
            {/* 
            */}
            <Route path="*" element={<ProtectedRoute><MedicationList /></ProtectedRoute>} />  
          </Routes>
        </div>
        <BottomNav />
  </div>
);
}
